import Cookies from 'js-cookie'

const state = {
    sidebar:{
        opened:Cookies.get('sidebarStatus')? !!+Cookies.get('sidebarStatus'):true
    },
    activeIndexTab: '',
    openTab: []
}

const mutations = {
    TOGGLE_SIDEBAR: state => {
        state.sidebar.opened = !state.sidebar.opened
        if(state.sidebar.opened){
            Cookies.set('sidebarStatus',1)
        }else {
            Cookies.set('sidebarStatus',0)
        }
    },
    CLOSE_SIDEBAR:(state) => {
      Cookies.set('sidebarStatus',0)
      state.sidebar.opened = false
    },
    setActiveIndexTab(state, data) {
        state.activeIndexTab = data
    },
    setOpenTab(state, data) {
        state.openTab.push(data)
    },
    refreshOpenTab(state, data) {
        state.openTab = data
    },
    deleteOpenTab(state, data) {
        state.openTab.forEach((element, index) => {
            if (element.path === data) {
                state.openTab.splice(index, 1)
            }
        })
        mutations.setActiveIndexTab(state,state.openTab[state.openTab.length - 1].path)
        // this.commit('setActiveIndexTab', state.openTab[state.openTab.length - 1].path)
    },
    /* 关闭其他 */
    closeOthers(state, data) {
        if(data=='/home'){
            state.openTab = state.openTab.filter(f => {
                /* 除了它以外的都不要 */
                return f.path === data
            })
        }else{
            let dataOne=state.openTab[0];
            state.openTab = state.openTab.filter(f => {
                /* 除了它以外的都不要 */
                return f.path === data
            })
            state.openTab[1]=state.openTab[0];
            state.openTab[0]=dataOne;
        }
        mutations.refreshOpenTab(state, state.openTab);
        // this.commit('refreshOpenTab', state.openTab)
        mutations.setActiveIndexTab(state,state.openTab[state.openTab.length - 1].path)
        // this.commit('setActiveIndexTab', state.openTab[state.openTab.length - 1].path)
    },
    /* 关闭当前 */
    closeSelected(state, data) {
        state.openTab = state.openTab.filter(f => {
            return f.path !== data
        })
        mutations.refreshOpenTab(state, state.openTab);
        // this.commit('refreshOpenTab', state.openTab)
        mutations.setActiveIndexTab(state,state.openTab[state.openTab.length - 1].path)
        // this.commit('setActiveIndexTab', state.openTab[state.openTab.length - 1].path)
    },
    /* 关闭所有 */
    closeAll(state, data) {
        mutations.refreshOpenTab(state, data);
        // this.commit('refreshOpenTab', data)
        mutations.setActiveIndexTab(state,state.openTab[state.openTab.length - 1].path)
        // this.commit('setActiveIndexTab', state.openTab[state.openTab.length - 1].path)
    }
}

const actions = {
    toggleSideBar({commit}){
        commit('TOGGLE_SIDEBAR')
    },
    closeSideBar({commit}){
         commit('CLOSE_SIDEBAR')
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
